/**
 *
 * OpenTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.majorelleBlueDark};
    background: ${COLORS.majorelleBlueLight};
    border-color: ${COLORS.majorelleBlue};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};
  }
`;

function OpenTag(props) {
  return <StyledTag label="Open" {...props} />;
}

export default memo(OpenTag);
